export const container = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    width: "100%",
};

export const content = { display: "flex", alignItems: "center", justifyContent: "center", flexGrow: 1, pt: 4 };
